export class Errors extends Error {
  readonly errors: Error[]
  constructor(errors: Error[]) {
    super(errors.map(error => error.message).join('\n'))
    Object.setPrototypeOf(this, new.target.prototype)
    this.errors = errors
  }
}
